/**
 * Breakpoint-based media query helpers.
 * Usage inside styled-components:
 *   ${media.md} { flex-direction: column; }
 */
export const media = {
  sm: '@media (max-width: 480px)',
  md: '@media (max-width: 768px)',
  lg: '@media (max-width: 1024px)',
  xl: '@media (max-width: 1280px)',
} as const;
